import { query } from '@confluence/query-preloader-tools';
import { ALLOWED_CONTENT_STATUSES } from '../constants';
import { LabelsQuery } from './LabelsQuery.graphql';
export function preloadLabels({ contentId }: { contentId: string }) {
	if (!contentId) {
		return Promise.resolve();
	}
	return query({
		query: LabelsQuery,
		variables: {
			contentId,
			status: ALLOWED_CONTENT_STATUSES,
			refetchQuery: false,
		},
		fetchPolicy: 'network-only',
	});
}
